import React from 'react';

export enum NotesIconVariation {
    View,
    Add
}

interface NotesIconOwnProps {
    variation: NotesIconVariation;
}

export const NotesIcon: React.SFC<NotesIconOwnProps> = props => {
    return (
        <svg viewBox="0 0 32 28" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="22.5" rx="2"/>
            <path d="M6 22 L6 28 L12 22Z"/>
            {props.variation === NotesIconVariation.View && (
                <g>
                    <rect x="8" y="5" width="16" height="3" fill="white"/>
                    <rect x="8" y="9.75" width="16" height="3" fill="white"/>
                    <rect x="8" y="14.5" width="16" height="3" fill="white"/>
                </g>
            )}
            {props.variation === NotesIconVariation.Add && (
                <g>
                    <rect x="14.5" y="4" width="3" height="14.5" fill="white"/>
                    <rect x="8.75" y="9.75" width="14.5" height="3" fill="white"/>
                </g>
            )}
        </svg>
    );
};
